import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hubspot-chat"
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.reinitialize = this.reinitialize.bind(this)
    document.addEventListener("turbo:render", this.reinitialize)

    if (window.HubSpotConversations) {
      this.initializeWidget()
    } else {
      window.hsConversationsOnReady = [() => this.initializeWidget()]
      this.loadScript()
    }
  }

  disconnect() {
    document.removeEventListener("turbo:render", this.reinitialize)
  }

  reinitialize() {
    if (window.HubSpotConversations) {
      this.initializeWidget()
    }
  }

  loadScript() {
    const script = document.createElement("script")
    script.src = this.urlValue
    script.onerror = (error) => {
      console.error("Failed to load HubSpot chat widget:", error)
    }
    document.head.appendChild(script)
  }

  initializeWidget() {
    window.HubSpotConversations.widget.remove()
    window.HubSpotConversations.widget.load()
  }
}
